import React, { Component } from 'react';
import radium from 'radium';

import block5BottomBg from '../static/images/Block5/block5BottomBg.png';
import cloud from '../static/images/Block5/cloud.png';
import sun from '../static/images/Block5/sun.png';
import twoStrike from '../static/images/Block5/twoStrike.png';
import arrowLeft from '../static/images/Block4/arrowLeft.png';
import arrowRight from '../static/images/Block4/arrowRight.png';
import homeRunTaiwanIcon from '../static/images/logo.png';
import { scrollElementLeftTo } from '../scrollTo';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '50px 0 0 0',
    position: 'relative',
  },
  bottomBackground: {
    backgroundImage: `url(${block5BottomBg})`,
    backgroundSize: 'cover',
    backgroundPosititon: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    paddingBottom: '66%',
    position: 'relative',
  },
  titleBlock: {
    width: 240,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EE8356',
    borderRadius: '20px',
    color: 'white',
    fontWeight: 600,
    letterSpacing: '3px',
    marginBottom: 40,
  },
  fbVideoBoard: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 0 50px 0',
    '@media (max-width: 1169px)': {
      paddingLeft: 30,
    },
  },
  fbVideoWrapper: {
    display: 'flex',
    width: '100%',
    maxWidth: 1066,
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    position: 'relative',
  },
  fbVideoPlacement: {
    width: '100%',
    height: 420,
    display: 'flex',
    alignItems: 'flex-start',
    overflowX: 'auto',
  },
  fbArticlePlacement: {
    width: '100%',
    height: 620,
    display: 'flex',
    alignItems: 'flex-start',
    overflowX: 'auto',
  },
  videoWrapper: {
    position: 'relative',
    display: 'flex',
  },
  videoPlacement: {
    width: '100%',
    maxWidth: 1066,
    display: 'flex',
    flexDirection: 'column',
  },
  prevBtn: {
    cursor: 'pointer',
    outline: 'none',
    border: 0,
    backgroundColor: 'transparent',
    padding: 0,
    width: 22,
    height: 37,
    position: 'absolute',
    top: 256,
    left: -50,
    transition: 'opacity 0.12s ease-out',
    '@media (max-width: 1169px)': {
      display: 'none',
    },
  },
  nextBtn: {
    left: 'auto',
    right: -50,
  },
  arrow: {
    width: 22,
    height: 37,
  },
  btnDisbaled: {
    pointer: 'default',
    opacity: 0.2,
    pointerEvents: 'none',
  },
  videoBlock: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 4px',
  },
  twoStrikeLogo: {
    width: 150,
    '@media (max-width: 414px)': {
      width: 90,
    },
  },
  homeRunTaiwanIcon: {
    width: 150,
    '@media (max-width: 414px)': {
      width: 90,
    },
  },
  footer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'absolute',
    bottom: 0,
    margin: '0 0 30px 0',
    '@media (max-width: 414px)': {
      bottom: -22,
    },
  },
  footerText: {
    fontSize: 10,
    color: 'white',
    letterSpacing: 2.31,
    margin: 0,
    '@media (max-width: 479px)': {
      letterSpacing: 0.8,
    },
  },
  sun: {
    width: 60,
    position: 'absolute',
    right: -90,
    bottom: 140,
    '@media (max-width: 1260px)': {
      right: 20,
      bottom: -40,
    },
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 0 10px 0',
  },
  cloud: {
    width: 150,
    position: 'absolute',
    top: -60,
    right: '18%',
    '@media (max-width: 600px)': {
      width: 100,
      top: -30,
    },
  },
  cloud2: {
    width: 200,
    position: 'absolute',
    left: -220,
    top: 150,
  },
};

const MARGIN_OF_ERROR = 10;

class Block5 extends Component {
  constructor(props) {
    super(props);

    this.videoScroller = React.createRef();
    this.articleScroller = React.createRef();

    this.state = {
      isVideoScrollerTouchedLeft: true,
      isVideoScrollerTouchedRight: true,
      isArticleScrollerTouchedLeft: true,
      isArticleScrollerTouchedRight: true,
    };

    this.onScrollListener = () => this.onScroll();
  }

  componentDidMount() {
    this.updateScrollerAnchor();

    this.videoScroller.current.addEventListener('scroll', this.onScrollListener);
    this.articleScroller.current.addEventListener('scroll', this.onScrollListener);
  }

  componentWillUnmount() {
    this.videoScroller.current.removeEventListener('scroll', this.onScrollListener);
    this.articleScroller.current.removeEventListener('scroll', this.onScrollListener);
  }

  onScroll() {
    this.setState(this.getScrollerState());
  }

  getScrollerState() {
    const videoScroller = this.videoScroller.current;
    const isVideoScrollerTouchedLeft = videoScroller.scrollLeft === 0;

    const isVideoScrollerTouchedRight = (videoScroller.scrollLeft + videoScroller.offsetWidth + MARGIN_OF_ERROR)
      >= (videoScroller.scrollWidth);
    const articleScroller = this.articleScroller.current;
    const isArticleScrollerTouchedLeft = articleScroller.scrollLeft === 0;
    const isArticleScrollerTouchedRight = (articleScroller.scrollLeft + articleScroller.offsetWidth + MARGIN_OF_ERROR)
      >= articleScroller.scrollWidth;

    return {
      isVideoScrollerTouchedLeft,
      isVideoScrollerTouchedRight,
      isArticleScrollerTouchedLeft,
      isArticleScrollerTouchedRight,
    };
  }

  nextPage(ref) {
    const scroller = ref.current;

    scrollElementLeftTo(
      scroller,
      (scroller.offsetWidth + scroller.scrollLeft),
      500,
      () => {
        if ((scroller.scrollLeft + scroller.offsetWidth) === scroller.scrollWidth) {
          this.setState(this.getScrollerState());
        }
      },
    );
  }

  prevPage(ref) {
    const scroller = ref.current;

    scrollElementLeftTo(
      scroller,
      (scroller.scrollLeft - scroller.offsetWidth),
      500,
      () => {
        if (scroller.scrollLeft === 0) {
          this.setState(this.getScrollerState());
        }
      },
    );
  }

  updateScrollerAnchor() {
    this.setState(this.getScrollerState());
  }

  render() {
    const {
      isVideoScrollerTouchedLeft,
      isVideoScrollerTouchedRight,
      isArticleScrollerTouchedLeft,
      isArticleScrollerTouchedRight,
    } = this.state;

    return (
      <div style={styles.wrapper}>
        <div style={styles.fbVideoBoard}>
          <div style={styles.fbVideoWrapper}>
            <button
              onClick={() => this.prevPage(this.videoScroller)}
              style={[styles.prevBtn, isVideoScrollerTouchedLeft && styles.btnDisbaled]}
              type="button">
              <img src={arrowLeft} style={[styles.arrow, styles.leftArrow]} alt="Prev Items" />
            </button>
            <div style={styles.titleBlock}>
              現正熱映
            </div>
            <div ref={this.videoScroller} style={styles.fbVideoPlacement} className="scroll">
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/456861798135116/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/537547330054308/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/170823057105510/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/274537843166003/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/321581088398897/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/1900516206921086/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/2200986003470221/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/477727242726769/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/529202687526229/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/1687660588029632/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/2663229730569837/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/1483277735107322/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/729970760689958/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/728839340787785/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/403278796870168/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/222093345123958/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/920366598158005/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/222093345123958/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/234418457216263/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/534650836968231/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/1068405369995533/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/1884252914976713/" />
              </div>
              <div style={styles.videoBlock}>
                <div
                  style={{ width: 350 }}
                  data-show-text="true"
                  className="fb-video"
                  data-allowfullscreen="true"
                  data-width="350"
                  data-href="https://www.facebook.com/2016homeruntaiwan/videos/1067028536799883/" />
              </div>
            </div>
            <button
              onClick={() => this.nextPage(this.videoScroller)}
              style={[
                styles.prevBtn,
                styles.nextBtn,
                isVideoScrollerTouchedRight && styles.btnDisbaled,
              ]}
              type="button">
              <img src={arrowRight} style={styles.arrow} alt="Next Items" />
            </button>
          </div>
        </div>
        <div style={styles.fbVideoBoard}>
          <div style={styles.fbVideoWrapper}>
            <button
              onClick={() => this.prevPage(this.articleScroller)}
              style={[styles.prevBtn, isArticleScrollerTouchedLeft && styles.btnDisbaled]}
              type="button">
              <img src={arrowLeft} style={[styles.arrow, styles.leftArrow]} alt="Prev Items" />
            </button>
            <div style={styles.titleBlock}>
              好文連載
            </div>
            <div ref={this.articleScroller} style={styles.fbArticlePlacement} className="scroll">
              <div style={styles.videoWrapper}>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1102360543266682/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1102202319949171/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1101268316709238/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1100650016771068/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1100568273445909/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1099578490211554/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1098765100292893/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1098731170296286/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1098240453678691/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1098171997018870/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1096659170503486/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1095975393905197/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1095315030637900/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1094157444086992/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1094142780755125/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1092767994225937/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1092766380892765/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1091019324400804/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1090992011070202/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1087801401389263/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1083651051804298/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1083641158471954/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1083636621805741/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1083061965196540/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1081046108731459/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1079666408869429/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1075852572584146/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1075828399253230/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1074946299341440/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1074063026096434/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1070625369773533/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{
                      width: 350,
                    }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1069410513228352/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{ width: 350 }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1069095606593176/" />
                </div>
                <div style={styles.videoBlock}>
                  <div
                    style={{ width: 350 }}
                    className="fb-post"
                    data-allowfullscreen="true"
                    data-width="350"
                    data-href="https://www.facebook.com/556055591230516/posts/1068392389996831/" />
                </div>
              </div>
            </div>
            <img style={styles.sun} src={sun} alt="太陽" />
            <img style={styles.cloud2} src={cloud} alt="雲" />
            <button
              onClick={() => this.nextPage(this.articleScroller)}
              style={[
                styles.prevBtn,
                styles.nextBtn,
                isArticleScrollerTouchedRight && styles.btnDisbaled,
              ]}
              type="button">
              <img src={arrowRight} style={styles.arrow} alt="Next Items" />
            </button>
          </div>
        </div>
        <div style={styles.bottomBackground}>
          <img style={[styles.cloud2, { width: 100, left: '16%', top: -40 }]} src={cloud} alt="雲" />
          <img style={styles.cloud} src={cloud} alt="雲" />
          <div style={styles.footer}>
            <div style={styles.iconWrapper}>
              <img style={styles.twoStrikeLogo} src={twoStrike} alt="倆好球標語" />
              <img src={homeRunTaiwanIcon} alt="homeRunTaiwanIcon" style={styles.homeRunTaiwanIcon} />
            </div>
            <p style={styles.footerText}>
              © 2018 CTBC. Proudly created with Rytass
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default radium(Block5);
